import Crud from '../views/City/Crud'
import Entity from '../views/City/Add'

let routes = {
    path: '/cities',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cities/add',
            name: 'Newcity',
            component: Entity,
            meta: {
                pageTitle: 'city.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'city.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cities/edit/:id?',
            name: 'Editcity',
            component: Entity,
            meta: {
                pageTitle: 'city.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'city.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cities',
            name: 'list-cities',
            component: Crud,
            meta: {
                pageTitle: 'city.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'city.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
